export default __webpack_public_path__ + "static/media/img-video-merchant-tools.1f1a00dd.jpg";